/* eslint-disable no-use-before-define */
import React from 'react'
import useSavedSearches from './use-saved-searches'
import { fmt, show, cleanObject } from '../twd'

export default () => {
    const { rows } = useSavedSearches({})

    return <React.Fragment>
        <div style={{background:"#f6f6f6"}}>
        <div className="container">
        <div className="row vertical-offset-lg"></div>

            <div className="row" style={{background:"#ffffff"}}>
            <div className="col-xs-12">
            <Grid rows={rows} />
            </div>
            </div>

        <div className="row vertical-offset-lg"></div>
        </div>
        </div>
        </React.Fragment>
}

const Grid = ({rows}) => (
    <div className="table-responsive">
    <table
        data-name="saved-searches-table"
        className="table table-hover align-top"
    >
        <thead>
        <tr>
        <th>Name</th>
        <th className="text-right">Last Modified</th>
        </tr>
    </thead>
    <tbody>{
        rows && rows.map( (r,i) => {
            return <tr
                data-name="saved-searches-row"
                className="row-has-checkbox" key={i}>
                <td><Item row={r} /></td>
                <td className="text-right">{fmt.ts(r.modified)}</td>
            </tr>
        })
    }</tbody>
    </table>
    </div>)


const Item = ({row}) => {
    return (
    <button
        data-name="saved-searches-item"
        data-label={row.description}

        className="btn-link"
        onClick={() => { onSearch(row) }}
    >{row.description}</button>
    )
}

const onSearch = ({searchParams}) => {
    show('offerings', Object.assign({
        searchParams: cleanObject(searchParams),
        _ts: Date.now(),
        from: 'saved-searches'
    }))
}



// WEBPACK FOOTER //
// ./src/saved-searches/saved-searches.js